export default __webpack_public_path__ + "static/media/Lasme.72702af8.jpg";